export enum ToggleButtonGroupTheme {
  roundedCompact,
  mergedLightBlueButtons,
  separatedWhiteButtons,
  sidebar,
  defaultButtons,
}
